class CardVariants extends HTMLElement {
  constructor() {
    super();
    this.card = this.closest('.card-wrapper, .card');
    
    // Find ALL links in the card (there might be multiple)
    this.productLinks = this.card?.querySelectorAll('a.full-unstyled-link, .card__heading a, .card__media a, .card a[href*="/products/"]') || [];
    
    // Find ALL images in the card (there might be multiple for hover effects)
    this.productImages = this.card?.querySelectorAll('.card__media img, .media img') || [];
    
    // Store original image data for all images
    this.originalImageData = Array.from(this.productImages).map(img => ({
      src: img.src,
      srcset: img.srcset
    }));
    
    // Store original URLs for all links
    this.originalUrls = Array.from(this.productLinks).map(link => link.href);
    
    this.init();
  }

  init() {
    // Intercept clicks at the card level before they reach the link
    if (this.card) {
      this.card.addEventListener('click', (e) => {
        // Check if click is on or inside a variant button
        const variantButton = e.target.closest('.card-variants__swatch, .card-variants__pill');
        
        if (variantButton) {
          // Prevent the card link from activating
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          this.handleVariantClick(variantButton);
          return false;
        }
      }, true); // Use capture phase
    }

    // Note: Removed the mouseleave reset so selected variant persists
  }

  handleVariantClick(button) {
    const variantId = button.dataset.variantId;
    const variantUrl = button.dataset.variantUrl;
    const variantImage = button.dataset.variantImage;
    const optionContainer = button.closest('.card-variants__option');

    console.log('Variant clicked:', { variantId, variantUrl, variantImage });

    // Update active state within the same option group
    if (optionContainer) {
      const siblingButtons = optionContainer.querySelectorAll('.card-variants__swatch, .card-variants__pill');
      siblingButtons.forEach(btn => btn.classList.remove('active'));
    }
    button.classList.add('active');

    // Update ALL product images if variant has an image
    if (variantImage && this.productImages.length > 0) {
      this.productImages.forEach(img => {
        img.src = variantImage;
        img.srcset = variantImage;
      });
      console.log('Updated', this.productImages.length, 'image(s) to:', variantImage);
    }

    // Update ALL product links to point to the variant
    if (variantUrl && this.productLinks.length > 0) {
      this.productLinks.forEach(link => {
        link.href = variantUrl;
      });
      console.log('Updated', this.productLinks.length, 'link(s) to:', variantUrl);
    }

    // Store the currently selected variant
    this.currentVariantId = variantId;
  }

  resetToOriginal() {
    // Reset all images to original
    if (this.productImages.length > 0 && this.originalImageData.length > 0) {
      this.productImages.forEach((img, index) => {
        if (this.originalImageData[index]) {
          img.src = this.originalImageData[index].src;
          if (this.originalImageData[index].srcset) {
            img.srcset = this.originalImageData[index].srcset;
          }
        }
      });
    }

    // Reset all links to original
    if (this.productLinks.length > 0 && this.originalUrls.length > 0) {
      this.productLinks.forEach((link, index) => {
        if (this.originalUrls[index]) {
          link.href = this.originalUrls[index];
        }
      });
    }

    // Remove active states
    const activeButtons = this.querySelectorAll('.card-variants__swatch.active, .card-variants__pill.active');
    activeButtons.forEach(btn => btn.classList.remove('active'));

    // Clear stored variant
    this.currentVariantId = null;
  }
}

// Register the custom element
if (!customElements.get('card-variants')) {
  customElements.define('card-variants', CardVariants);
}

// Initialize all card variants on the page
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.card-variants').forEach(element => {
    if (!element.classList.contains('initialized')) {
      element.classList.add('initialized');
    }
  });
});

// Re-initialize after any dynamic content loads (for infinite scroll, etc.)
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.card-variants:not(.initialized)').forEach(element => {
      element.classList.add('initialized');
    });
  });
}